// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursor-pointer[data-v-69a711ea] {\n  cursor: pointer;\n}\n.cursor-default[data-v-69a711ea] {\n  cursor: default;\n}", ""]);
// Exports
module.exports = exports;
